// @flow
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {EdapProvider} from '@homeaway/react-event-tracking';
import Experiment, {On} from '@homeaway/react-experiment';
import FlexibleDates from './FlexibleDates';
import {media} from '../../utils/breakpoints';
import routerActions from '../../actions/router';
import flexDatesActions from '../../actions/flexDates';
import {VRBO_WEB_FLEX_DATE_A_INSIGHT} from '../../abacus/experiments';

import type {State as ReduxState} from '../../reducers/index';
import type {PercentBookedResult} from '../../queries/searchRequestQuery';

type StateProps = {
    startDate?: string,
    endDate?: string,
    locale: string,
    isDesktop: boolean,
    previousSearchTerm?: string,
    searchTerm?: string
};

type OwnProps = {
    loading: boolean,
    resultCount?: number,
    percentBooked?: PercentBookedResult
};

type DispatchProps = {
    search: typeof routerActions.search,
    toggleSubsequentFlexDatesView: typeof flexDatesActions.toggleSubsequentFlexDatesView
};

type Props = StateProps & DispatchProps & OwnProps;

export function FlexibleDatesContainer({
    search,
    toggleSubsequentFlexDatesView,
    previousSearchTerm,
    searchTerm,
    percentBooked,
    resultCount,
    ...props
}: Props) {
    useEffect(() => {
        if (previousSearchTerm !== searchTerm) {
            toggleSubsequentFlexDatesView(false);
        }
    }, [previousSearchTerm, searchTerm, toggleSubsequentFlexDatesView]);

    function onDateChange(arrival: string, departure: string) {
        search({arrival, departure});
        toggleSubsequentFlexDatesView(true);
    }

    const defaultFields = {
        eventcategory: 'flexible dates'
    };

    return (
        <Experiment name={VRBO_WEB_FLEX_DATE_A_INSIGHT}>
            <On>
                <EdapProvider fields={defaultFields}>
                    <FlexibleDates
                        resultCount={resultCount}
                        {...props}
                        onDateChange={onDateChange}
                    />
                </EdapProvider>
            </On>
        </Experiment>
    );
}

const mapStateToProps = ({
    searchParams: {
        params: {arrival, departure, q: searchTerm},
        prevParams: {q: previousSearchTerm}
    },
    system: {locale},
    viewport: {breakpoint}
}: ReduxState): StateProps => {
    return {
        startDate: arrival,
        endDate: departure,
        locale,
        isDesktop: media(breakpoint, {
            minWidth: 'SM_MIN'
        }),
        previousSearchTerm,
        searchTerm
    };
};

const mapDispatchToProps = {
    search: routerActions.search,
    toggleSubsequentFlexDatesView:
        flexDatesActions.toggleSubsequentFlexDatesView
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FlexibleDatesContainer);
